import React, { useState } from "react";
import { Box, Tab, Tabs, Typography, ThemeProvider } from "@mui/material";
import { Boxes, History, Package, Settings2, ShoppingBag, Store } from "lucide-react";
import dashboardTheme from "../../theme/dashboardTheme";
import EcommOrders from "./EcommOrders";
import ManageProducts from "./ManageProducts";
import ShopSettings from "./ShopSettings";
import EcommInventory from "./EcommInventory";

const sections = [
  { label: "Orders", icon: ShoppingBag },
  { label: "Manage products", icon: Package },
  { label: "Inventory", icon: Boxes },
  { label: "Stock history", icon: History },
  { label: "Shop Settings", icon: Settings2 },
];

export default function EcommWorkspace({ businessId }: { businessId: string }) {
  const [tab, setTab] = useState(0);
  const panels = [<EcommOrders businessId={businessId} />, <ManageProducts businessId={businessId} />,
    <EcommInventory businessId={businessId} />, <EcommInventory businessId={businessId} historyOnly />, <ShopSettings businessId={businessId} />];
  return <ThemeProvider theme={dashboardTheme}>
    <Box sx={{ containerType: "inline-size", containerName: "ecomm", bgcolor: "background.default", minHeight: "100%", width: "100%", minWidth: 0, textAlign: "left" }}>
      <Box sx={{ bgcolor: "background.paper", px: { xs: 2, md: 3 }, pt: 3, borderBottom: "1px solid", borderColor: "divider" }}>
        <Box sx={{ maxWidth: 1440, mx: "auto" }}>
          <Box sx={{ display: "flex", gap: 1.5, alignItems: "center", mb: 2 }}>
            <Box sx={{ display: "grid", placeItems: "center", flexShrink: 0, width: 48, height: 48, bgcolor: "primary.main", color: "primary.contrastText", borderRadius: "12px 12px 12px 3px" }}><Store size={23} strokeWidth={1.7} /></Box>
            <Box><Typography component="h1" sx={{ fontSize: { xs: 26, md: 30 }, fontWeight: 700, letterSpacing: "-.045em", lineHeight: 1.3 }}>E-commerce</Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mt: .5 }}>Orders, products and stock for your WhatsApp store.</Typography></Box>
          </Box>
          <Tabs value={tab} onChange={(_, next) => setTab(next)} aria-label="Ecomm tabs" variant="scrollable" scrollButtons="auto" allowScrollButtonsMobile sx={{ mx: { xs: -2, md: 0 }, "& .MuiTabs-indicator": { height: 3, borderRadius: "3px 3px 0 0" } }}>
            {sections.map(({ label, icon: Icon }, i) => <Tab key={label} icon={<Icon size={17} strokeWidth={1.8} />} iconPosition="start" label={label} id={`ecomm-tab-${i}`} aria-controls={`ecomm-panel-${i}`} />)}
          </Tabs>
        </Box>
      </Box>
      <Box role="tabpanel" tabIndex={0} key={`${businessId}:${tab}`} id={`ecomm-panel-${tab}`} aria-labelledby={`ecomm-tab-${tab}`} sx={{ maxWidth: 1500, mx: "auto", minWidth: 0 }}>{panels[tab]}</Box>
    </Box>
  </ThemeProvider>;
}
